import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import {
    FETCH_MASTER_CODES_REQUEST,
    FETCH_MASTER_CODES_SUCCESS,
    FETCH_MASTER_CODES_FAILURE,
    CREATE_OR_UPDATE_MASTER_CODE_REQUEST,
    CREATE_OR_UPDATE_MASTER_CODE_SUCCESS,
    CREATE_OR_UPDATE_MASTER_CODE_FAILURE,
} from './Types';
import { newTracking } from './AppActions';
import { message } from 'antd';
import { db } from '../App';

// Fetch Master Codes with Real-Time Updates
// export const fetchMasterCodes = () => (dispatch) => {
//   dispatch({ type: FETCH_MASTER_CODES_REQUEST });
//   try {
//     const unsubscribe = onSnapshot(
//       collection(db, 'masterCodes'),
//       (querySnapshot) => {
//         const codes = [];
//         querySnapshot.forEach((doc) => {
//           codes.push({ key: doc.id, ...doc.data() });
//         });
//         dispatch({ type: FETCH_MASTER_CODES_SUCCESS, payload: codes });
//       },
//       (error) => {
//         dispatch({ type: FETCH_MASTER_CODES_FAILURE, payload: error.message });
//       }
//     );

//     // Return the unsubscribe function to handle cleanup
//     return unsubscribe;
//   } catch (error) {
//     dispatch({ type: FETCH_MASTER_CODES_FAILURE, payload: error.message });
//   }
// };

export const fetchMasterCodes = (type) => async (dispatch) => {
    dispatch({ type: FETCH_MASTER_CODES_REQUEST });

    try {
        const docRef = doc(db, 'masterCodes', type);

        // Attach onSnapshot listener
        onSnapshot(
            docRef,
            (doc) => {
                if (doc.exists()) {
                    dispatch({
                        type: FETCH_MASTER_CODES_SUCCESS,
                        payload: doc.data(),
                    });
                } else {
                    dispatch({
                        type: FETCH_MASTER_CODES_FAILURE,
                        payload: 'No master codes found',
                    });
                }
            },
            (error) => {
                dispatch({
                    type: FETCH_MASTER_CODES_FAILURE,
                    payload: error.message,
                });
            }
        );
    } catch (error) {
        dispatch({
            type: FETCH_MASTER_CODES_FAILURE,
            payload: error.message,
        });
    }
};

// Create or Update Master Code
// export const createOrUpdateMasterCode = (code) => async (dispatch) => {
//   dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_REQUEST });
//   try {
//     if (code.key === 'new') {
//       // Create new code
//       await addDoc(collection(db, 'masterCodes'), {
//         name: code.name,
//         value: code.value,
//       });
//     } else {
//       // Update existing code
//       const codeRef = doc(db, 'masterCodes', code.key);
//       await updateDoc(codeRef, {
//         name: code.name,
//         value: code.value,
//       });
//     }
//     dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_SUCCESS });
//   } catch (error) {
//     dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_FAILURE, payload: error.message });
//   }
// };

export const createOrUpdateMasterCode = (type, data) => async (dispatch) => {
    dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_REQUEST });
    try {

        await setDoc(
            doc(db, 'masterCodes', type),
            {
                staffCode: data.staffCode,
                // parentCode: data.parentCode,
            },
            { merge: true }
        );
        
        dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_SUCCESS });

        message.success('Master codes updated successfully!');

        // Dispatching the newTracking action
        dispatch(newTracking(
            'Master Code',
            `Create or Update Master Code`,
            'completed',
            {
                type
            }
        ));

    } catch (error) {
        dispatch({ type: CREATE_OR_UPDATE_MASTER_CODE_FAILURE, payload: error.message });

        message.error('Failed to update Master codes.');
    }
};

